import { render, staticRenderFns } from "./WSurveyEdit.vue?vue&type=template&id=2b9af0db&"
import script from "./WSurveyEdit.vue?vue&type=script&lang=ts&"
export * from "./WSurveyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports